(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-refresh-session.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-refresh-session.js');
"use strict";


const {
  format
} = svs.utils;
const {
  services,
  logger
} = svs.sportsbook.sbtech_api_impl;
let lastCall;
svs.sportsbook.sbtech_api_impl.fns.requests.sbtech_refreshSession = post => () => services.accountBalance(accountBalance => {
  const now = Date.now();
  logger.debug("sbtech_refreshSession called ".concat(new Date()));
  if (lastCall) {
    logger.debug("sbtech_refreshSession call diff ".concat((now - lastCall) / 1000));
  }
  lastCall = now;
  post({
    status: svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) ? 'success' : 'failure',
    message: '',
    balance: format.Currency(accountBalance) || ''
  });
});

 })(window);